import { Layout } from 'antd';
import styled, { css } from 'styled-components';

const { Sider } = Layout;

export const appSiderWidthStyle = css`
  width: 200px;
`;

export const StyledSider = styled(Sider).attrs(() => ({
  trigger: null,
  collapsible: true,
  collapsedWidth: 45,
  width: 205,
}))`
  max-height: 100vh;
  overflow: hidden auto;
  background: inherit;
  display: flex;
  flex-direction: column;
  position: sticky;
  top: 0;
`;

export const SiderContent = styled.div``;

export const StyledMenuButton = styled.div`
  cursor: pointer;
  font-size: 12px;
  color: white;
  background: #643d52;
  border-radius: 3px;
  z-index: 1;
  transition: background-color 0.5s ease, transform 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 25px;
  margin: 10px;
  padding: ${({ theme }) => theme.spacing.space_2};
  &:hover {
    background: #805c72;
  }
`;
